<template>
  <div id="main" class="app full-width">
    <router-view />
  </div>
</template>

<script>
// что то делаем до рендера публичных страниц(все страницы) основого приложения
export default {
  name: 'Outer'
};
</script>
